export type TestimonialRole = "client" | "therapist" | "hr";

export const TESTIMONIAL_ROLES: readonly TestimonialRole[] = ["client", "therapist", "hr"];

/**
 * Where a curated testimonial is rendered. `home` is the "Šta kažu naši klijenti"
 * marquee on the homepage; `therapists` is the quote carousel on /za-terapeute.
 * One pool, one admin screen, two placements.
 */
export type TestimonialPlacement = "home" | "therapists";

export const TESTIMONIAL_PLACEMENTS: readonly TestimonialPlacement[] = ["home", "therapists"];

export function isTestimonialPlacement(value: unknown): value is TestimonialPlacement {
  return TESTIMONIAL_PLACEMENTS.includes(value as TestimonialPlacement);
}

/** Admin-curated testimonial (homepage marquee or the /za-terapeute carousel). */
export interface Testimonial {
  id: string;
  placement: TestimonialPlacement;
  name: string;
  role: TestimonialRole;
  /** Free-text role line, e.g. "Terapeutkinja na Psihotronu". Only `therapists` uses it. */
  roleBs: string;
  roleEn: string;
  quoteBs: string;
  quoteEn: string;
  /** Long version behind "Pročitaj čitavu recenziju". Empty hides the button. */
  fullQuoteBs: string;
  fullQuoteEn: string;
  avatarUrl: string;
  rating: number;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

/** Public shape served to the site — no audit/order fields. */
export interface PublicTestimonial {
  id: string;
  placement: TestimonialPlacement;
  name: string;
  role: TestimonialRole;
  roleBs: string;
  roleEn: string;
  quoteBs: string;
  quoteEn: string;
  fullQuoteBs: string;
  fullQuoteEn: string;
  avatarUrl: string;
  rating: number;
}
